/* eslint-disable @typescript-eslint/no-unused-vars */
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Divider, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, Tab, Tabs, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { LayoutBase } from '../../../../../layouts';
import { VMenu } from '../../../../../components/shared';
import { Add, CloudUpload, ScreenRotationAlt } from '@mui/icons-material';
import { IReadings, IReadingsInstruments, ReadingServices } from '../../../../../services/api/reading/ReadingServices';
import { ToolsDamInformation, LineChartInstrument, AllInstrument, Pluviometry, AllPluviometry, Landmarks, AllLandmarks } from '../../../../../components/custom';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {/* Alterar o componente Typography para usar uma tag div */}
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const InstrumentationGeotechnicalRecords = () => {
  const url = useParams();
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('xl'));
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));

  const [value, setValue] = React.useState(0);
  const [instrument, setInstrument] = useState<string>('');

  const [mobile, setMobile] = useState(false);
  const portrait = useMediaQuery('(orientation: portrait)');

  const [data, setData] = useState<IReadingsInstruments[]>([]);
  const [flatInstrument, setFlatInstrument] = useState<IReadings[]>([]);
  const [nameInstrument, setNameInstrument] = useState<string[]>([]);


  useEffect(() => {
    fetchData();
  }, [url.id]);

  const fetchData = () => {
    if (url.id && url.id !== 'novo') {
      ReadingServices.getAll(url.id)
        .then((response) => { 
          if (response instanceof Error) {
            setData([]);
          } else {
            setData(response);
          }
        })
        .catch(error => {
          setData([]); 
        });
    } else {
      setData([]); 
    }
  };

  useEffect(() => {
    const verifyScreen = () => {
      if (smDown) {
        setMobile(true);
      } else {
        setMobile(false);
      }
    };

    verifyScreen();
  }, [url, smDown, portrait]);

  const handleOrientationChange = async (orientation: 'portrait' | 'landscape') => {
    try {
      const screenOrientation = screen.orientation as ScreenOrientation & {
        lock: (orientation: OrientationType) => Promise<void>;
      };

      if (orientation === 'portrait') {
        await screenOrientation.lock('portrait-primary');
      } else {
        await screenOrientation.lock('landscape-primary');
      }
    } catch (error) {
      console.error('Erro ao mudar a orientação:', error);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleInstrument = (event: any) => {
    setInstrument(event.target.value);
    getInstrumentCharts(event.target.value);
  };

  const navigate = useNavigate();
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };


  function getInstrumentCharts(type: string | null) {		
    if (type === 'piezometro') {
      const intrumentFilter = ReadingServices.getReading(data, type);
      setFlatInstrument(intrumentFilter.flatData);
      setNameInstrument(intrumentFilter.names);
    } else if (type === 'vazao') {
      const intrumentFilter = ReadingServices.getReading(data, type);
      setFlatInstrument(intrumentFilter.flatData);
      setNameInstrument(intrumentFilter.names);
    } else if (type === 'indicador') {
      const intrumentFilter = ReadingServices.getReading(data, type);
      setFlatInstrument(intrumentFilter.flatData);
      setNameInstrument(intrumentFilter.names);
    } else if (type === 'regua') {
      const intrumentFilter = ReadingServices.getReading(data, type);
      setFlatInstrument(intrumentFilter.flatData);
      setNameInstrument(intrumentFilter.names);
    } else if (type === 're') {
      const intrumentFilter = ReadingServices.getReading(data, type);
      setFlatInstrument(intrumentFilter.flatData);
      setNameInstrument(intrumentFilter.names);
    } else if (type === 'pluviometro') {
      const intrumentFilter = ReadingServices.getReading(data, type);
      setFlatInstrument(intrumentFilter.flatData);
      setNameInstrument(intrumentFilter.names);
    } else if (type === 'marco') {
      const intrumentFilter = ReadingServices.getReading(data, type);
      setFlatInstrument(intrumentFilter.flatData);
      setNameInstrument(intrumentFilter.names);
    } else if (type === 'inclinometro') {
      const intrumentFilter = ReadingServices.getReading(data, type);
      setFlatInstrument(intrumentFilter.flatData);
      setNameInstrument(intrumentFilter.names);
    }else if( type == null) {
			console.log('teste');
		}
  }


  const instrumentosDesabilitados = [
    'marco_deformacao_conduto',
    'piezometro_pneumatico',
    'marco_superficial',
    'placa_de_recalque',
    'caixa_sueca',
    'poco_de_alivio',
    'celula_de_pressao_total'
  ];



  return (
    <LayoutBase
      title='Registro de monitoramento'
      tollBar={<ToolsDamInformation />}
    >
      <Box width={'100%'}>
        <VMenu id={url.id} />
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} justifyContent={'space-around'} display={'flex'}>
          <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons allowScrollButtonsMobile>
            <Tab label="Registro de Monitoramento" {...a11yProps(0)} />
            {/* <Tab label="Mapa" {...a11yProps(1)} />
            <Tab label="Plotagem Linha Freática" {...a11yProps(2)} />
            <Tab label="Registros Históricos" {...a11yProps(3)} /> */}
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <Box width={'100%'}>
            {mobile ? <>
              <Box width={'100%'}>
                <Grid container alignItems={'center'}>
                  <Grid item xs={10} alignContent={'center'} justifyContent={'center'} textAlign={'center'}>
                    <Typography variant='body2'>Vire o celular para visualizar os gráficos</Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <IconButton onClick={() => handleOrientationChange('landscape')}><ScreenRotationAlt color='primary' /></IconButton>
                  </Grid>
                  <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button variant='contained' sx={{ borderRadius: '25px' }} startIcon={<Add />} onClick={() => navigate(`/information_dam/${url.id}/instrument_reading`)}>Novo</Button>
                    <Button variant='contained' sx={{ borderRadius: '25px' }} startIcon={<CloudUpload />} onClick={() => navigate(`/information_dam/${url.id}/instrument_reading/import`)}>Importar</Button>
                  </Grid>
                </Grid>
              </Box>
            </> : <>
              <Box width={'100%'}>
                <Grid container spacing={2} padding={2}>
                  <Grid item container spacing={2} alignItems={'center'}>
                    <Grid item xs={4}>
                      <FormControl fullWidth>
                        <InputLabel>Instrumento</InputLabel>
                        <Select label='instrumento' value={instrument} onChange={handleInstrument}>
                          <MenuItem value='piezometro'>Piezômetro</MenuItem>
                          <MenuItem value='indicador'>Indicador de nível da água</MenuItem>
                          <MenuItem value='vazao'>Medidor de vazão</MenuItem>
                          <MenuItem value='regua'>Régua de reservatório</MenuItem>
                          <MenuItem value='re'>Ré topográfica</MenuItem>
                          <MenuItem value='pluviometro'>Pluviometrico</MenuItem>
                          <MenuItem value='marco'>Marco Topográfico</MenuItem>
                          <MenuItem value='inclinometro'>Inclinômetro</MenuItem>
                          <MenuItem value='marco_deformacao_conduto'>Marco de deformação do conduto</MenuItem>
                          <MenuItem value='piezometro_pneumatico'>Piezômetro pneumático</MenuItem>
                          <MenuItem value='marco_superficial'>Marco superficial</MenuItem>
                          <MenuItem value='placa_de_recalque'>Placa de recalque</MenuItem>
                          <MenuItem value='caixa_sueca'>Caixa sueca</MenuItem>
                          <MenuItem value='poco_de_alivio'>Poço de alívio</MenuItem>
                          <MenuItem value='celula_de_pressao_total'>Célula de pressão total</MenuItem>

                          {/* <MenuItem value='todos'>Todos</MenuItem> */}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={4}>
                      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                        <Button
                          variant='contained'
                          onClick={() => navigate(`/information_dam/${url.id}/instrument_reading`)}
                          startIcon={<Add />}
                          sx={{ borderRadius: '25px' }}
                          disabled={instrumentosDesabilitados.includes(instrument)}
                        >
                          Novo
                        </Button>
                        <Button
                          variant='contained'
                          onClick={() => navigate(`/information_dam/${url.id}/instrument_reading/import`)}
                          startIcon={<CloudUpload />}
                          sx={{ borderRadius: '25px' }}
                          disabled={instrumentosDesabilitados.includes(instrument)}
                        >
                          Importar
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                  {instrument == 'indicador' ? (
                    <Grid container>
                      <Grid item container xs={12}>
                        {nameInstrument.map(name => {
                          const dataForName = flatInstrument.filter(index => index.nome === name);
                          return (
                            mdUp ? (
                              <Grid item xs={6} key={name}>
                                <LineChartInstrument
                                  data={dataForName}
                                  name={name}
                                  lineKey={['cota']}
                                  multLine={false}
                                  yText="Cota (m)"
                                  xAxis="data_leitura"
                                  yAxis="cota"
                                />
                              </Grid>
                            ) : (
                              <Grid item xs={12} key={name}>
                                <LineChartInstrument
                                  data={dataForName}
                                  name={name}
                                  multLine={false}
                                  lineKey={['cota']}
                                  yText="Cota (m)"
                                  xAxis="data_leitura"
                                  yAxis="cota"
                                />
                              </Grid>
                            )
                          );
                        })}
                      </Grid>
                    </Grid>
                  ) : null}
                  {instrument === 'piezometro' ? (
                    <Grid container>
                      <Grid item container xs={12}>
                        {nameInstrument.map(name => {
                          const dataForName = flatInstrument
                            .filter(index => index.nome === name)
                            .map(item => ({
                              ...item,
                              cota: item.cota.replace(',', '.'),
                              profundidade_pio: item.profundidade_pio.replace(',', '.')
                            }));

                          return (
                            mdUp ? (
                              <Grid item xs={6} key={name}>
                                <LineChartInstrument
                                  data={dataForName}
                                  name={name}
                                  lineKey={['cota']}
                                  yText="Cota (m)"
                                  xAxis="data_leitura"
                                  yAxis="cota"
                                />
                              </Grid>
                            ) : (
                              <Grid item xs={12} key={name}>
                                <LineChartInstrument
                                  data={dataForName}
                                  name={name}
                                  lineKey={['cota']}
                                  yText="Cota (m)"
                                  xAxis="data_leitura"
                                  yAxis="cota"
                                />
                              </Grid>
                            )
                          );
                        })}
                      </Grid>
                    </Grid>
                  ) : null}
                  {instrument === 'regua' ? (
                    <Grid container>
                      <Grid item container xs={12}>
                        {nameInstrument.map(name => {
                          const dataForName = flatInstrument.filter(index => index.nome === name);
                          return (
                            mdUp ? (
                              <Grid item xs={6} key={name}>
                                <LineChartInstrument
                                  data={dataForName}
                                  name={name}
                                  lineKey={['borda_livre']}
                                  yText="Borda Livre (m)"
                                  xAxis="data_leitura"
                                  yAxis="borda_livre"
                                />
                              </Grid>
                            ) : (
                              <Grid item xs={12} key={name}>
                                <LineChartInstrument
                                  data={dataForName}
                                  name={name}
                                  lineKey={['borda_livre']}
                                  yText="Borda Livre (m)"
                                  xAxis="data_leitura"
                                  yAxis="borda_livre"
                                />
                              </Grid>
                            )
                          );
                        })}
                      </Grid>
                    </Grid>
                  ) : null}
                  {instrument === 're' ? (
                    <Grid container>
                      <Grid item container xs={12}>
                        {nameInstrument.map(name => {
                          const dataForName = flatInstrument.filter(index => index.nome === name);
                          return (
                            mdUp ? (
                              <Grid item xs={6} key={name}>
                                <LineChartInstrument
                                  data={dataForName}
                                  name={name}
                                  lineKey={['angulo']}
                                  yText="Ângulo"
                                  xAxis="data_leitura"
                                  yAxis="angulo"
                                />
                              </Grid>
                            ) : (
                              <Grid item xs={12} key={name}>
                                <LineChartInstrument
                                  data={dataForName}
                                  name={name}
                                  lineKey={['angulo']}
                                  yText="Ângulo"
                                  xAxis="data_leitura"
                                  yAxis="angulo"
                                />
                              </Grid>
                            )
                          );
                        })}
                      </Grid>
                    </Grid>
                  ) : null}
                  {instrument === 'pluviometro' ? (
                    <Grid container>
                      <Grid item container xs={12}>
                        {nameInstrument.map(name => {
                          const dataForName = flatInstrument.filter(index => index.nome === name);

                          return (
                            mdUp ? (
                              <Grid item xs={6} key={name}>
                                <Pluviometry
                                  data={dataForName}
                                  name={name}
                                  barKey={['leitura_diaria']}
                                  yText="Precipitação (mm)"
                                  xAxis="data_leitura"
                                  yAxis="leitura_diaria"
                                />
                              </Grid>
                            ) : (
                              <Grid item xs={12} key={name}>
                                <Pluviometry
                                  data={dataForName}
                                  name={name}
                                  barKey={['leitura_diaria']}
                                  yText="Precipitação (mm)"
                                  xAxis="data_leitura"
                                  yAxis="leitura_diaria"
                                />
                              </Grid>
                            )
                          );
                        })}
                      </Grid>
                    </Grid>
                  ) : null}
                  {instrument === 'marco' ? (
                    <Grid container>
                      <Grid item container xs={12}>
                        {nameInstrument.map(name => {
                          const dataForName = flatInstrument.filter(index => index.nome === name);

                          return (
                            mdUp ? (
                              <Grid item xs={12} key={name}>
                                <Landmarks
                                  data={dataForName}
                                />
                              </Grid>
                            ) : (
                              <Grid item xs={12} key={name}>
                                <Landmarks
                                  data={dataForName}
                                />
                              </Grid>
                            )
                          );
                        })}
                      </Grid>
                    </Grid>
                  ) : null}
                  {instrument === 'vazao' ? (
                    <Grid container>
                      <Grid item container xs={12}>
                        {nameInstrument.map(name => {
                          const dataForName = flatInstrument.filter(index => index.nome === name);
                          return (
                            mdUp ? (
                              <Grid item xs={6} key={name}>
                                <LineChartInstrument
                                  data={dataForName}
                                  name={name}
                                  lineKey={['vazao']}
                                  yText="Vazão (m³/s)"
                                  xAxis="data_leitura"
                                  yAxis="vazao"
                                />
                              </Grid>
                            ) : (
                              <Grid item xs={12} key={name}>
                                <LineChartInstrument
                                  data={dataForName}
                                  name={name}
                                  lineKey={['vazao']}
                                  yText="Vazão (m³/s)"
                                  xAxis="data_leitura"
                                  yAxis="vazao"
                                />
                              </Grid>
                            )
                          );
                        })}
                      </Grid>
                    </Grid>
                  ) : null}
                  {instrument == 'inclinometro' ? (
                    <Grid container>
                      <Grid item container xs={12}>
                        {nameInstrument.map(name => {
                          const dataForName = flatInstrument.filter(index => index.nome === name);
                          return (
                            mdUp ? (
                              <Grid item xs={6} key={name}>
                                <LineChartInstrument
                                  data={dataForName}
                                  name={name}
                                  lineKey={['deslocamento']}
                                  multLine={false}
                                  yText="Deslocamento (mm)"
                                  xAxis="data_leitura"
                                  yAxis="deslocamento"
                                />
                              </Grid>
                            ) : (
                              <Grid item xs={12} key={name}>
                                <LineChartInstrument
                                  data={dataForName}
                                  name={name}
                                  multLine={false}
                                  lineKey={['deslocamento']}
                                  yText="Deslocamento(mm)"
                                  xAxis="data_leitura"
                                  yAxis="deslocamento"
                                />
                              </Grid>
                            )
                          );
                        })}
                      </Grid>
                    </Grid>
                  ) : null}
                  {instrument == 'todos' ? <>
                    <Grid item container>
                      <Grid item xs={12}>
                        <Typography>Piezometros</Typography>
                        <AllInstrument value={data} type='piezometro' yAxisName='Cota (m³)' key={'piezometro'} />
                        <Divider />
                      </Grid>
                    </Grid>

                    {/* <Grid item container>
                      <Grid item xs={12}>
                        <Typography>Indicador de nível de água</Typography>
                        <AllInstrument value={data} type='indicador' yAxisName='Cota (m³)' key={'indicador'} />
                        <Divider />
                      </Grid>
                    </Grid>

                    <Grid item container>
                      <Grid item xs={12}>
                        <Typography>Medidor de vazao</Typography>
                        <AllInstrument value={data} type='vazao' yAxisName='Vazão (m/s)' key={'medidor'} />
                        <Divider />
                      </Grid>
                    </Grid>

                    <Grid item container>
                      <Grid item xs={12}>
                        <Typography>Régua de reservatório</Typography>
                        <AllInstrument value={data} type='regua' yAxisName='Borda Livre (m)' key={'regua'} />
                        <Divider />
                      </Grid>
                    </Grid>

                    <Grid item container>
                      <Grid item xs={12}>
                        <Typography>Ré topográfica</Typography>
                        <AllInstrument value={data} type='re' yAxisName='Ângulo' key={'re'} />
                        <Divider />
                      </Grid>
                    </Grid>

                    <Grid item container>
                      <Grid item xs={12}>
                        <Typography>Pluviometro</Typography>
                        <AllPluviometry value={data} type='pluviometro' key={'pluviometro'} />
                        <Divider />
                      </Grid>
                    </Grid>

                    <Grid item container>
                      <Grid item xs={12}>
                        <Typography>Marco Topográfico</Typography>
                        <AllLandmarks value={data} type='marco' key={'marco'} />
                        <Divider />
                      </Grid>
                    </Grid>

                    <Grid item container>
                      <Grid item xs={12}>
                        <Typography>Inclinometro</Typography>
                        <AllInstrument value={data} type='inclinometro' yAxisName='Deslocamento(mm)' key={'inclinometro'} />
                        <Divider />
                      </Grid>
                    </Grid> */}

                  </> : <></>}
                </Grid>
              </Box>
            </>}
          </Box>
        </CustomTabPanel>
      </Box>
    </LayoutBase>
  );
};